import { MS_DAY, START_TIME } from '../constants';

// ---------------------------------------------------
// Dates
// ---------------------------------------------------

export const getDayIdByDate = date =>
  Math.max(Math.floor((date.getTime() - START_TIME) / MS_DAY), 0);
export const getDateByDayId = dayId => new Date(START_TIME + dayId * MS_DAY);

// ---------------------------------------------------
// Stats
// ---------------------------------------------------

export const statsEvent = (eName, eValue) => {
  if (typeof window.dpAnalytics !== 'undefined') {
    window.dpAnalytics.trackEvent('Program-68', eName, eValue);
  }
};



// WEBPACK FOOTER //
// ./src/utils/index.js